const Erro404 = () => import(/* webpackChunkName: "erro404" */ './Erro404.vue')

const route = {
  path: '*',
  name: 'Error',
  component: Erro404,
  meta: {
    requiresLogin: false,
    requiresCompany: false,
    permissions: []
  }
}

export default {
  route
}
